import React, { useEffect, useState } from "react"
import axios from "axios"
const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

interface TipoCombustivel { id: string; nome: string; ativo: boolean }

export default function TiposCombustivel() {
  const [tipos, setTipos] = useState<TipoCombustivel[]>([])
  const [novoNome, setNovoNome] = useState("")
  const [editando, setEditando] = useState<TipoCombustivel | null>(null)
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro] = useState("")

  const token = () => localStorage.getItem("moobi_token")
  const headers = () => ({ Authorization: `Bearer ${token()}` })

  const carregar = async () => {
    const r = await axios.get(`${API}/tipos-combustivel`, { headers: headers() })
    setTipos(r.data)
  }

  useEffect(() => {
    (async () => {
      setCarregando(true)
      await carregar()
      setCarregando(false)
    })()
  }, [])

  const criar = async () => {
    if (!novoNome.trim()) return
    setErro("")
    try {
      await axios.post(`${API}/tipos-combustivel`, { nome: novoNome.trim() }, { headers: headers() })
      setNovoNome("")
      await carregar()
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao criar") }
  }

  const salvarEdicao = async () => {
    if (!editando) return
    try {
      await axios.put(`${API}/tipos-combustivel/${editando.id}`, { nome: editando.nome }, { headers: headers() })
      setEditando(null)
      await carregar()
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao editar") }
  }

  const excluir = async (t: TipoCombustivel) => {
    if (!window.confirm(`Remover o tipo de combustível "${t.nome}"?`)) return
    await axios.delete(`${API}/tipos-combustivel/${t.id}`, { headers: headers() })
    await carregar()
  }

  const corFundo = "#0d1b2e", corCard = "#1e2f4a", corBorda = "#2d4166", corTexto = "#f1f5f9", corMuted = "#94a3b8", corAccent = "#0ea5e9"

  const estiloInput: React.CSSProperties = {
    flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${corBorda}`,
    background: corCard, color: corTexto, fontSize: 13, boxSizing: "border-box",
  }
  const estiloBotao: React.CSSProperties = {
    padding: "9px 16px", borderRadius: 8, border: "none", cursor: "pointer",
    background: corAccent, color: "#fff", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap",
  }
  const estiloLinha: React.CSSProperties = {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
    borderRadius: 8, border: `1px solid ${corBorda}`, marginBottom: 6, maxWidth: 420,
  }
  const estiloIconeAcao: React.CSSProperties = { cursor: "pointer", color: corMuted, fontSize: 15, padding: 4 }

  if (carregando) return <div style={{ padding: 32, color: corMuted }}>Carregando...</div>

  return (
    <div style={{ padding: 24, height: "100%", overflow: "auto", background: corFundo, color: corTexto }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Tipos de Combustível</h2>
      <p style={{ fontSize: 12, color: corMuted, marginBottom: 20 }}>
        Catálogo usado no cadastro de ativos.
      </p>
      {!!erro && <div style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{erro}</div>}

      <div style={{ display: "flex", gap: 8, marginBottom: 14, maxWidth: 420 }}>
        <input style={estiloInput} placeholder="Ex: Gasolina" value={novoNome}
          onChange={e => setNovoNome(e.target.value)} onKeyDown={e => e.key === "Enter" && criar()} />
        <button style={estiloBotao} onClick={criar}>+ Adicionar</button>
      </div>

      {tipos.map(t => (
        <div key={t.id} style={estiloLinha}>
          {editando?.id === t.id ? (
            <>
              <input style={estiloInput} value={editando.nome}
                onChange={e => setEditando({ ...editando, nome: e.target.value })} autoFocus />
              <span style={estiloIconeAcao} onClick={salvarEdicao}>✅</span>
              <span style={estiloIconeAcao} onClick={() => setEditando(null)}>✖️</span>
            </>
          ) : (
            <>
              <span style={{ flex: 1, fontSize: 13 }}>{t.nome}</span>
              <span style={estiloIconeAcao} onClick={() => setEditando(t)}>✏️</span>
              <span style={estiloIconeAcao} onClick={() => excluir(t)}>🗑️</span>
            </>
          )}
        </div>
      ))}
      {tipos.length === 0 && <div style={{ color: corMuted, fontSize: 12 }}>Nenhum tipo cadastrado ainda.</div>}
    </div>
  )
}
